<template>
  <megabit-base-dialog :show-dialog="true" :width="800">
    <template v-slot:body>
      <v-card color="rgba(0, 0, 0, 0.8)">
        <v-card-title class="align-self-center">
          <span class="text-h6">Cadastro de Marcas (alt+r)</span>
        </v-card-title>
        <v-card-text>
          <v-form v-model="formValid" ref="form">
            <c-input
              label="Marca"
              placeholder="Digite o nome da marca"
              :minLength="3"
              :maxLength="40"
              :isRequired="true"
              v-model.trim="form.NOME"
            />
          </v-form>
        </v-card-text>
        <form-buttons @submitForm="submitForm()" @goBack="goBack()"/>
      </v-card>
    </template>
  </megabit-base-dialog>
</template>

<script>
import BaseDialog from '@/components/shared/base-dialog/BaseDialog'
import cInput from '@/components/shared/base-input/BaseInput'
import FormButtons from '@/components/shared/base-buttons/FormButtons'
import { formRegisterMixin } from '@/mixins/component/form/FormRegisterMixin'

import { mapActions } from 'vuex'
export default {
  mixins: [formRegisterMixin],
  components: { 'megabit-base-dialog': BaseDialog, cInput, FormButtons },
  data: () => {
    return {
      form: {
        NOME: '',
      },
      formValid: false,
      isUpdate: false,
    }
  },
  methods: {
    ...mapActions({
      getBrand: 'brandModule/getBrand'
    }),

    async setData() {
      try {
        if (this.$route.params && this.$route.params.id) {
          const data = await this.getBrand(this.$route.params.id)
          this.form.NOME = data.NOME
          this.isUpdate = !this.isUpdate
        }
      } catch (error) {
        this.$toasted.error(error, {duration: null});
      }
    },
  },
  mounted() {
    this.setData()
  },
}
</script>

<style></style>
